import { createApp } from 'vue'

export const App = {
    delimiters: ['[[', ']]'],
    data() {
      return {
        loginRequired: false,
      }
    },

    methods: {
      handleModalClose() {
        this.loginRequired = false
      },
      handleLoginRequired() {
        this.loginRequired = true
      },
    }
}
if (document.getElementById('app')) {
    createApp(App).mount('#app')
}
